import React from 'react';
import { useSEO } from '../hooks/useSEO';
import { FRONTEND_URL } from '../config';

const Blog: React.FC = () => {
  useSEO({
    title: 'Blog | Kostüm Akademi',
    description: 'Kostüm Akademi blog sayfası - çok yakında sizlerle olacak',
    canonical: `${FRONTEND_URL}/blog`,
    keywords: 'kostüm blog, kostüm akademi blog, kostüm ipuçları',
    ogImage: `${FRONTEND_URL}/logo.png`,
    ogType: 'website',
  });

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#ffffff',
      fontFamily: '"Inter", "Segoe UI", -apple-system, sans-serif',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem'
    }}>
      <div style={{
        textAlign: 'center',
        maxWidth: '600px',
        padding: '3rem 2rem',
        backgroundColor: '#f8fafc',
        borderRadius: '20px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
        border: '1px solid #e2e8f0'
      }}>
        <div style={{
          fontSize: '4rem',
          marginBottom: '2rem',
          color: '#668A69'
        }}>
          📝
        </div>
        
        <h1 style={{
          fontSize: '1.3rem',
          fontWeight: '400',
          color: '#111827',
          marginBottom: '1.5rem',
          fontFamily: '"Inter", "Segoe UI", -apple-system, sans-serif'
        }}>
          Blog sayfamız çok yakında sizlerle olacak!
        </h1>
        
    
        
        <div style={{
          fontSize: '1rem',
          color: '#6b7280',
          lineHeight: '1.5',
          marginBottom: '2.5rem',
          fontFamily: '"Inter", "Segoe UI", -apple-system, sans-serif'
        }}>
          Kostüm seçimi, bakım ipuçları ve daha fazlası için blog yazılarımızı takip edin.
        </div>
        
        <div style={{
          display: 'flex',
          gap: '1rem',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <a
            href="/"
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#668A69',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '8px',
              fontSize: '1rem',
              fontWeight: '500',
              transition: 'background-color 0.2s ease',
              fontFamily: '"Inter", "Segoe UI", -apple-system, sans-serif'
            }}
            onMouseOver={(e) => (e.target as HTMLAnchorElement).style.backgroundColor = '#567a5a'}
            onMouseOut={(e) => (e.target as HTMLAnchorElement).style.backgroundColor = '#668A69'}
          >
            Ana Sayfaya Dön
          </a>
          
          <a
            href="/costumes"
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: 'transparent',
              color: '#668A69',
              textDecoration: 'none',
              borderRadius: '8px',
              fontSize: '1rem',
              fontWeight: '500',
              border: '2px solid #668A69',
              transition: 'all 0.2s ease',
              fontFamily: '"Inter", "Segoe UI", -apple-system, sans-serif'
            }}
            onMouseOver={(e) => {
              (e.target as HTMLAnchorElement).style.backgroundColor = '#668A69';
              (e.target as HTMLAnchorElement).style.color = 'white';
            }}
            onMouseOut={(e) => {
              (e.target as HTMLAnchorElement).style.backgroundColor = 'transparent';
              (e.target as HTMLAnchorElement).style.color = '#668A69';
            }}
          >
            Kostümleri Keşfet
          </a>
        </div>
      </div>
    </div>
  );
};

export default Blog;
